export const displayViewData = {
    creditNoteDisplayView: {
        entity: 'creditNote',
        path: 'creditNote',
        titleBar: { mergeParams: ['number'] },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    id: 'creditNoteDisplayView.send',
                    action: 'send',
                    label: 'all.form.button.send',
                    icon: 'send',
                    variant: 'primary',
                    confirm: true,
                    modalConfig: 'invoiceSendDialog'
                }
            ],
            menuItems: [
                {
                    action: 'save',
                    label: 'all.menu.item.save',
                    confirm: false
                },
                {
                    action: 'archive',
                    label: 'all.menu.item.archive',
                    confirm: false,
                    dependency: { id: 'archived', value: false }
                },
                {
                    action: 'unarchive',
                    label: 'all.menu.item.unarchive',
                    confirm: false,
                    dependency: { id: 'archived', value: true }
                },
                {
                    action: 'match',
                    label: 'all.menu.item.match',
                    confirm: false,
                    removeQueryParams: ["invoice", "creditNote"],
                    dependency: { id: 'paid', value: false }
                },
                {
                    action: 'reset',
                    label: 'all.menu.item.reset',
                    confirm: false,
                    removeQueryParams: ["invoice", "creditNote"],
                    dependency: { id: 'paid', value: false }
                },
                {
                    action: 'unmatch',
                    label: 'all.menu.item.unmatch',
                    confirm: false,
                    removeQueryParams: ["invoice", "creditNote"],
                    dependency: { id: 'paid', value: true }
                },
                {
                    action: 'repost',
                    actionType: 'post',
                    label: 'all.menu.item.repost',
                    confirm: true,
                    modalConfig: 'creditNoteConfirmRepost',
                    dependency: { id: 'ledgerPosted', value: false }
                }
            ],
            actions: {
                repost: { message: 'ledger.repost.complete', reload: true },
                archive: { message: 'creditNote.action.archive.message' },
                unarchive: { message: 'creditNote.action.unarchive.message' },
                match: { message: 'creditNote.action.match.message' },
                reset: { message: 'creditNote.action.reset.message' },
                unmatch: { message: 'creditNote.action.unmatch.message' }
            }
        },
        width: '100%',
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'actionButton',
                    title: 'all.form.button.preview',
                    entity: 'invoice',
                    modalFormRef: 'documentPreview'
                },
                {
                    type: 'optionPanel',
                    id: 'optionPanel',
                    items: [
                        {
                            type: 'modal',
                            title: 'invoice.form.mobile.panel.design',
                            action: 'showModal',
                            icon: 'design',
                            modalFormRef: 'invoiceDesign'
                        }
                    ]
                }
            ]
        },
        sections: [
            {
                id: 'creditNoteViewPage',
                meta: {
                    type: 'regular',
                    width: '900px'
                },
                displaySection: {
                    type: 'regular',
                    emptyField: 'number',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 5,
                            basis: '50%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title',
                                    prefix: 'document.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 5,
                            basis: '50%',
                            align: 'right',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'customerName',
                                    scale: 'title',
                                    icon: 'people',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'customerEmail',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['customerAddress_street', 'customerAddress_postCode', 'customerAddress_city', 'customerCountryName'],
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'invoiceLines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    width: '900px',
                },
                displaySection: {
                    type: 'lines',
                    emptyField: 'itemName',
                    emptyMessage: 'invoice.form.product.missing.message',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    linesArray: 'lines',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'netSalesAmount',
                                    scale: 'title',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'text',
                                    value: 'DKK',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ],
                        }
                    ]
                }
            },
            {
                id: 'invoiceSummary',
                meta: {
                    type: 'totals',
                    width: '900px',
                    align: 'end',
                    variant: 'transparent'
                },
                displaySection: {
                    type: 'totals',
                    elements: [
                        {
                            type: 'line',
                            value: 'totalNetSalesAmountBeforeDiscount',
                            scale: 'normal',
                            label: 'invoice.form.subtotal',
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount.percentage',
                            // The multiplier form is what keeps this a bare 10
                            // rather than a formatted 10.00 -- the same idiom the
                            // VAT row uses to turn a rate into a percentage.
                            labelParams: [['documentDiscountValue', 1]],
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'percentage' }
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'amount' }
                        },
                        {
                            type: 'line',
                            value: 'totalNetSalesAmount',
                            scale: 'normal',
                            label: 'all.form.total.taxable',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        },
                        {
                            type: 'array',
                            value: 'vatTaxAmount',
                            subEntity: 'vatTaxes',
                            scale: 'normal',
                            label: 'invoice.form.vatLine',
                            labelParams: [['vatTaxRate', 100], 'vatTaxAmount'],
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'totalGrossSalesAmount',
                            scale: 'large',
                            label: 'invoice.form.total',
                            decorator: 'currency'
                        }
                    ]
                }
            },
            {
                id: 'invoiceTerms',
                meta: {
                    type: 'regular',
                    width: '900px',
                },
                displaySection: {
                    emptyField: 'terms',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'all.display.terms',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'terms',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
        ]
    },
    expenseDisplayView: {
        entity: 'expense',
        path: 'expense',
        titleBar: { mergeParams: ['bookedNumber'] },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [],
            menuItems: [
                {
                    action: 'archive',
                    label: 'all.menu.item.archive',
                    confirm: false,
                    dependency: { id: 'archived', value: false }
                },
                {
                    action: 'unarchive',
                    label: 'all.menu.item.unarchive',
                    confirm: false,
                    dependency: { id: 'archived', value: true }
                }
            ],
            actions: {
                archive: { message: 'purchases.expense.action.archive.message' },
                unarchive: { message: 'purchases.expense.action.unarchive.message' }
            }
        },
        width: '100%',
        // Unpaid → match a payment out; paid or part-paid → review the matches.
        notifications: [
            {
                type: 'error',
                message: 'purchases.expense.display.message.unpaid',
                condition: { field: 'hasPayment', operator: 'equals', value: false },
                button: {
                    action: 'registerPayment',
                    actionType: 'showModal',
                    label: 'purchases.expense.display.button.registerPayment',
                    path: 'expense/:id/registerPayment',
                    variant: 'yellow',
                    modalFormRef: 'matchExpensePayment',
                    $brightBackground: true
                }
            },
            {
                type: 'success',
                message: 'purchases.expense.display.message.paid',
                condition: { field: 'paid', operator: 'equals', value: true },
                button: {
                    action: 'reviewPayment',
                    actionType: 'navigate',
                    label: 'purchases.expense.display.button.reviewPayment',
                    path: 'payment',
                    variant: 'primary',
                    $brightBackground: true
                }
            },
            {
                type: 'warning',
                message: 'purchases.expense.display.message.partially.paid',
                condition: { all: [{ field: 'paid', operator: 'equals', value: false }, { field: 'hasPayment', operator: 'equals', value: true }] },
                button: {
                    action: 'reviewPayment',
                    actionType: 'navigate',
                    label: 'purchases.expense.display.button.reviewPayment',
                    path: 'payment',
                    variant: 'primary',
                    $brightBackground: true
                }
            }
        ],
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'documents',
                    title: 'purchases.expense.mobile.documents',
                    modalTitle: 'purchases.expense.mobile.documents',
                    entity: 'expense',
                    icon: 'attachment',
                    count: {
                        arrays: ['attachments'],
                        condition: { field: 'source', operator: 'equals', value: 'purchaseOrder' }
                    },
                    modalFormRef: 'expenseDocuments'
                }
            ]
        },
        sections: [
            {
                id: 'expenseDisplayHeader',
                meta: {
                    type: 'regular',
                    width: '900px'
                },
                displaySection: {
                    type: 'regular',
                    emptyField: 'bookedNumber',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 4,
                            basis: '40%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'bookedNumber',
                                    scale: 'title',
                                    prefix: 'purchases.expense.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                },
                                {
                                    type: 'field',
                                    value: 'supplierInvoiceNumber',
                                    scale: 'normal',
                                    prefix: 'purchases.expense.form.supplierInvoiceNumber.prefix',
                                    condition: { field: 'supplierInvoiceNumber', operator: 'notEmpty' }
                                },
                                {
                                    type: 'field',
                                    value: 'purchaseOrderNumber',
                                    scale: 'normal',
                                    prefix: 'purchases.expense.form.purchaseOrder.prefix',
                                    condition: { field: 'purchaseOrderNumber', operator: 'notEmpty' }
                                }
                            ]
                        },
                        {
                            weight: 6,
                            basis: '60%',
                            align: 'right',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'supplierName',
                                    scale: 'title',
                                    icon: 'people',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['supplierAddress_street', 'supplierAddress_postCode', 'supplierAddress_city', 'supplierCountryName'],
                                    scale: 'normal',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'date',
                                    value: 'paymentDate',
                                    scale: 'normal',
                                    prefix: 'purchases.expense.form.paymentDate.prefix',
                                    variant: 'noMargin'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'expenseDisplayLines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    width: '900px',
                },
                displaySection: {
                    type: 'lines',
                    emptyField: 'itemName',
                    emptyMessage: 'purchases.expense.form.line.add',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    linesArray: 'lines',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} ${2}',
                                    mergeParams: ['expenseAccountNumber', 'expenseAccountIdName'],
                                    scale: 'normal',
                                    condition: { field: 'expenseAccountId', operator: 'notEmpty' }
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'grossAmount',
                                    scale: 'title',
                                    decorator: 'currency',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'itemTaxName',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'expenseSummary',
                meta: {
                    type: 'totals',
                    width: '900px',
                    align: 'end',
                    variant: 'transparent'
                },
                displaySection: {
                    type: 'totals',
                    elements: [
                        {
                            type: 'line',
                            value: 'totalNetAmount',
                            scale: 'normal',
                            label: 'purchases.expense.form.subtotal',
                            decorator: 'currency'
                        },
                        {
                            type: 'array',
                            value: 'vatTaxAmount',
                            subEntity: 'vatTaxes',
                            scale: 'normal',
                            label: 'purchases.expense.form.vatLine',
                            labelParams: [['vatTaxRate', 100], 'vatTaxAmount'],
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'totalGrossAmount',
                            scale: 'large',
                            label: 'purchases.expense.form.total',
                            decorator: 'currency'
                        }
                    ]
                }
            }
        ]
    },
    inventoryLedgerDisplayView: {
        entity: 'inventoryLedger',
        path: 'inventoryLedger',
        titleBar: { mergeParams: ['documentNumber'] },
        width: '100%',
        sections: [
            {
                id: 'inventoryLedgerDisplayHeader',
                meta: {
                    type: 'regular',
                    width: '600px'
                },
                displaySection: {
                    type: 'regular',
                    emptyField: 'documentNumber',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 6,
                            basis: '50%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'documentNumber',
                                    scale: 'title',
                                    icon: 'boxes',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'documentEntity',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 6,
                            basis: '50%',
                            align: 'right',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'itemName',
                                    scale: 'title',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'locationId',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'type',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'amount',
                                    value: 'delta',
                                    scale: 'title',
                                    variant: 'noMargin'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },
    invoiceDisplayView: {
        entity: 'invoice',
        path: 'invoice',
        titleBar: { mergeParams: ['number'] },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    id: 'invoiceDisplayView.send',
                    action: 'send',
                    label: 'all.form.button.send',
                    icon: 'send',
                    variant: 'primary',
                    confirm: true,
                    modalConfig: 'invoiceSendDialog'
                }
            ],
            menuItems: [
                {
                    action: 'save',
                    label: 'all.menu.item.save',
                    confirm: false
                },
                {
                    action: 'archive',
                    label: 'all.menu.item.archive',
                    confirm: false,
                    dependency: { id: 'archived', value: false }
                },
                {
                    action: 'unarchive',
                    label: 'all.menu.item.unarchive',
                    confirm: false,
                    dependency: { id: 'archived', value: true }
                },
                {
                    action: 'credit',
                    label: 'all.menu.item.credit',
                    confirm: true,
                    modalConfig: 'invoiceConfirmCredit',
                    target: '/sales/creditNote/newFromInvoice/:id'
                },
                {
                    action: 'repost',
                    actionType: 'post',
                    label: 'all.menu.item.repost',
                    confirm: true,
                    modalConfig: 'invoiceConfirmRepost',
                    dependency: { id: 'ledgerPosted', value: false }
                }
            ],
            actions: {
                archive: { message: 'invoice.action.archive.message' },
                unarchive: { message: 'invoice.action.unarchive.message' },
                repost: { message: 'ledger.repost.complete', reload: true }
            }
        },
        width: '100%',
        notifications: [
            {
                type: 'error',
                message: 'invoice.display.message.unpaid',
                condition: { field: 'hasPayment', operator: 'equals', value: false },
                button: {
                    action: 'registerPayment',
                    actionType: 'showModal',
                    label: 'invoice.display.button.registerPayment',
                    path: 'invoice/:id/registerPayment',
                    variant: 'yellow',
                    modalFormRef: 'matchPayment',
                    $brightBackground: true
                }
            },
            {
                type: 'success',
                message: 'invoice.display.message.paid',
                condition: { field: 'paid', operator: 'equals', value: true },
                button: {
                    action: 'reviewPayment',
                    actionType: 'navigate',
                    label: 'invoice.display.button.reviewPayment',
                    path: 'payment',
                    variant: 'primary',
                    //modalFormRef: 'matchPayment',
                    $brightBackground: true
                }
            },
            {
                type: 'warning',
                message: 'invoice.display.message.partially.paid',
                condition: { all: [{ field: 'paid', operator: 'equals', value: false }, { field: 'hasPayment', operator: 'equals', value: true }] },
                button: {
                    action: 'reviewPayment',
                    actionType: 'navigate',
                    label: 'invoice.display.button.reviewPayment',
                    path: 'payment',
                    variant: 'primary',
                    //modalFormRef: 'matchPayment',
                    $brightBackground: true
                }
            }
        ],
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'actionButton',
                    title: 'all.form.button.preview',
                    entity: 'invoice',
                    modalFormRef: 'documentPreview'
                },
                {
                    type: 'optionPanel',
                    id: 'optionPanel',
                    items: [
                        {
                            type: 'modal',
                            title: 'invoice.form.mobile.panel.design',
                            action: 'showModal',
                            icon: 'design',
                            modalFormRef: 'invoiceDesign'
                        }
                    ]
                }
            ]
        },

        sections: [
            {
                id: 'invoiceHeader',
                meta: {
                    type: 'regular',
                    width: '900px'
                },
                displaySection: {
                    type: 'regular',
                    emptyField: 'number',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 4,
                            basis: '40%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title',
                                    prefix: 'invoice.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 6,
                            basis: '60%',
                            align: 'right',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'customerName',
                                    scale: 'title',
                                    icon: 'people',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'customerEmail',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['customerAddress_street', 'customerAddress_postCode', 'customerAddress_city', 'customerCountryName'],
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'invoiceLines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    width: '900px',
                },
                displaySection: {
                    type: 'lines',
                    emptyField: 'itemName',
                    emptyMessage: 'invoice.form.product.missing.message',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    linesArray: 'lines',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'netSalesAmount',
                                    scale: 'title',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'currency',
                                    value: 'currency',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ],
                        }
                    ]
                }
            },
            {
                id: 'invoiceSummary',
                meta: {
                    type: 'totals',
                    width: '900px',
                    align: 'end',
                    variant: 'transparent'
                },
                displaySection: {
                    type: 'totals',
                    elements: [
                        {
                            type: 'line',
                            value: 'totalNetSalesAmountBeforeDiscount',
                            scale: 'normal',
                            label: 'invoice.form.subtotal',
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount.percentage',
                            // The multiplier form is what keeps this a bare 10
                            // rather than a formatted 10.00 -- the same idiom the
                            // VAT row uses to turn a rate into a percentage.
                            labelParams: [['documentDiscountValue', 1]],
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'percentage' }
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'amount' }
                        },
                        {
                            type: 'line',
                            value: 'totalNetSalesAmount',
                            scale: 'normal',
                            label: 'all.form.total.taxable',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        },
                        {
                            type: 'array',
                            value: 'vatTaxAmount',
                            subEntity: 'vatTaxes',
                            scale: 'normal',
                            label: 'invoice.form.vatLine',
                            labelParams: [['vatTaxRate', 100], 'vatTaxAmount'],
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'totalGrossSalesAmount',
                            scale: 'large',
                            label: 'invoice.form.total',
                            decorator: 'currency'
                        }
                    ]
                }
            },
            {
                id: 'invoiceTerms',
                meta: {
                    type: 'regular',
                    width: '900px',
                },
                displaySection: {
                    emptyField: 'terms',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'all.display.terms',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'terms',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
        ]
    },
    journalDisplayView: {
        entity: 'journal',
        path: 'journal',
        titleBar: { mergeParams: ['description'] },
        cardTitle: {
            title: 'all.form.button.more',
            menuItems: [
                {
                    action: 'reverse',
                    label: 'journal.form.menu.reverse',
                    confirm: true,
                    modalConfig: 'journalConfirmReverse',
                    // A reversal can be reversed too — that is how an entry
                    // reversed by mistake is put back.
                    dependency: { id: 'state', value: ['posted', 'reversing'] }
                },
                {
                    action: 'archive',
                    label: 'all.menu.item.archive',
                    confirm: false,
                    dependency: { id: 'archived', value: false }
                },
                {
                    action: 'unarchive',
                    label: 'all.menu.item.unarchive',
                    confirm: false,
                    dependency: { id: 'archived', value: true }
                }
            ],
            actions: {
                reverse: { message: 'journal.action.reverse.message', reload: true },
                archive: { message: 'journal.action.archive.message' },
                unarchive: { message: 'journal.action.unarchive.message' }
            }
        },
        width: '900px',
        sections: [
            {
                id: 'journalViewHeader',
                meta: {
                    type: 'regular',
                    width: '900px'
                },
                displaySection: {
                    type: 'regular',
                    emptyField: 'description',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 5,
                            basis: '50%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'description',
                                    scale: 'title',
                                    icon: 'paper'
                                },
                                {
                                    // J-26-000001: issued when the journal was
                                    // posted, by whoever posted it.
                                    type: 'field',
                                    value: 'number',
                                    scale: 'normal',
                                    prefix: 'journal.display.number',
                                    condition: { field: 'number', operator: 'notEmpty' }
                                },
                                {
                                    /*
                                     * Two elements rather than one showing `state`
                                     * raw: a ledger read by people should not say
                                     * 'posted' in a language that has a word for
                                     * it. Draft never reaches this view — the page
                                     * routes a draft to the editable card.
                                     *
                                     * A pill, not a line of text, so the one word
                                     * that classifies the whole journal does not
                                     * read as another label in the column above it.
                                     */
                                    type: 'statusPill',
                                    value: 'journal.display.state.posted',
                                    scale: 'other',
                                    condition: { field: 'state', operator: 'equals', value: 'posted' },
                                    variant: 'success'
                                },
                                {
                                    // The journal that cancels another; its link
                                    // to that original sits right below.
                                    type: 'statusPill',
                                    value: 'journal.display.state.reversing',
                                    scale: 'other',
                                    condition: { field: 'state', operator: 'equals', value: 'reversing' },
                                    variant: 'warning'
                                },
                                {
                                    type: 'statusPill',
                                    value: 'journal.display.state.reversed',
                                    scale: 'other',
                                    condition: { field: 'state', operator: 'equals', value: 'reversed' },
                                    variant: 'warning'
                                },
                                {
                                    /*
                                     * Where the posting came from. The ledger has
                                     * always known — `source` carries the kind,
                                     * the id and the number — and a reader could
                                     * see the description and had no way to open
                                     * the invoice behind it.
                                     *
                                     * MANUAL_JOURNAL is deliberately absent: its
                                     * source is itself, so there is nowhere to go
                                     * and DisplayLink draws nothing.
                                     *
                                     * No `condition` — DisplayLink decides, and it
                                     * has to: `field` in the shared condition
                                     * language is a flat key, so a predicate on
                                     * 'source.type' is quietly always false.
                                     */
                                    type: 'docLink',
                                    value: 'source.type',
                                    textField: 'source.number',
                                    pathMap: {
                                        SALES_INVOICE: '/sales/invoice/${source.id}',
                                        CREDIT_NOTE: '/sales/creditNote/${source.id}',
                                        // A payment's own `source.id` is the
                                        // invoicePayment line ('<invoiceId>.1'),
                                        // which is not a route — the invoice is
                                        // what a reader wants opened.
                                        PAYMENT: '/sales/invoice/${source.invoiceId}',
                                        PURCHASE_EXPENSE: '/purchases/expense/${source.id}',
                                        // A supplier payment's source is the expense it paid.
                                        EXPENSE_PAYMENT: '/purchases/expense/${source.id}',
                                        REVERSAL: '/accounting/journal/${source.id}'
                                    },
                                    scale: 'normal',
                                    labelMap: {
                                        SALES_INVOICE: 'journal.display.source.invoice',
                                        CREDIT_NOTE: 'journal.display.source.creditNote',
                                        // The same word as a sale's, because the
                                        // link goes to the same kind of page. A
                                        // label naming the RELATIONSHIP ("Payment
                                        // of invoice") only restated the
                                        // description right above it.
                                        PAYMENT: 'journal.display.source.invoice',
                                        PURCHASE_EXPENSE: 'journal.display.source.expense',
                                        EXPENSE_PAYMENT: 'journal.display.source.expense',
                                        REVERSAL: 'journal.display.source.reversal'
                                    },
                                    icon: 'document'
                                },
                                {
                                    // The correction itself, once one exists. The
                                    // original is never edited, so this link is
                                    // the only way from it to what replaced it.
                                    type: 'docLink',
                                    value: 'state',
                                    textField: 'reversal.byJournalNumber',
                                    pathMap: { reversed: '/accounting/journal/${reversal.byJournalId}' },
                                    scale: 'normal',
                                    labelMap: { reversed: 'journal.display.reversedBy' }
                                }
                            ]
                        },
                        {
                            weight: 5,
                            basis: '50%',
                            align: 'right',
                            elements: [
                                {
                                    // Debit/credit side by side — a balanced
                                    // journal always shows the same figure
                                    // twice, so seeing both makes the balance
                                    // check visual instead of two separate
                                    // numbers the reader has to compare.
                                    //
                                    // Decorated with `baseCurrency`, not
                                    // `transactionCurrency`: both totals are base
                                    // amounts (every posting ruleset sums the
                                    // legs' baseAmount into them), so labelling
                                    // them with the document's currency put the
                                    // wrong code on the right number — invisible
                                    // while the two match, and wrong on every
                                    // foreign-currency invoice.
                                    type: 'merge',
                                    value: '${1}/${2} ${3}',
                                    mergeParams: [
                                        { type: 'amount', value: 'totalDebitBase' },
                                        { type: 'amount', value: 'totalCreditBase' },
                                        'baseCurrency'
                                    ],
                                    scale: 'title'
                                },
                                {
                                    // The dates sit under the amount, where a
                                    // document's header keeps them, so the left
                                    // column says what the journal is and the
                                    // right one when and how much.
                                    type: 'date',
                                    value: 'accountingDate',
                                    scale: 'normal',
                                    prefix: 'journal.form.accountingDate'
                                },
                                {
                                    // When the entry was actually made, which is a
                                    // different fact from the date it is booked
                                    // under and the one an audit asks for. To the
                                    // minute: two postings on the same day are
                                    // ordered by nothing else.
                                    type: 'datetime',
                                    value: 'postedAt',
                                    scale: 'normal',
                                    prefix: 'journal.display.enteredAt',
                                    condition: { field: 'postedAt', operator: 'notEmpty' }
                                },
                                {
                                    // What the document was denominated in, shown
                                    // only when that is not the currency the
                                    // totals above are in — otherwise it repeats
                                    // the line above it.
                                    type: 'field',
                                    value: 'transactionCurrency',
                                    scale: 'normal',
                                    prefix: 'journal.display.currency',
                                    condition: { field: 'transactionCurrency', operator: 'notEquals', valueFrom: 'values.baseCurrency' }
                                },
                                {
                                    // Only when it does not. A posting refuses an
                                    // unbalanced journal, so this should never
                                    // show — which is exactly why it is worth
                                    // showing if it ever does. A green "balanced"
                                    // badge on every journal would say nothing.
                                    type: 'text',
                                    value: 'journal.display.balanced.no',
                                    scale: 'normal',
                                    condition: { field: 'balanced', operator: 'equals', value: false },
                                    variant: 'error'
                                },
                                {
                                    type: 'field',
                                    value: 'bookId',
                                    scale: 'normal',
                                    prefix: 'journal.display.book'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'journalViewLines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    // A posted journal's lines still take documents
                    // (lineDocumentsData); removing one only marks it deleted.
                    lineDocuments: 'journalLine',
                    width: '900px'
                },
                displaySection: {
                    type: 'lines',
                    // accountId is always present (every line references an
                    // account); accountIdName only is when the line was built
                    // by the manual-journal card's connect picker — postSale/
                    // postCreditNote/postPayment/postReversal's lines[] never
                    // set it (see their linesBuild compute step). Keying
                    // emptyField on accountIdName made Display.jsx treat every
                    // line from those rulesets as "empty" and hide it entirely
                    // (showEmptyPrompt: false means nothing renders in its
                    // place either) — accountId is the field that's actually
                    // never missing.
                    emptyField: 'accountId',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    // As on the journal card: one column on a phone.
                    stackOnMobile: true,
                    linesArray: 'lines',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    // A ledger is read by number as much as by
                                    // name: "1010 — Sales of goods". Both are
                                    // denormalized onto the line at posting
                                    // time, so this still reads correctly after
                                    // someone renumbers the account.
                                    type: 'merge',
                                    value: '${1} — ${2}',
                                    mergeParams: ['accountNo', 'accountIdName'],
                                    scale: 'title',
                                    condition: { field: 'accountNo', operator: 'notEmpty' }
                                },
                                {
                                    type: 'field',
                                    value: 'accountIdName',
                                    scale: 'title',
                                    condition: { all: [
                                        { field: 'accountNo', operator: 'empty' },
                                        { field: 'accountIdName', operator: 'notEmpty' }
                                    ] }
                                },
                                {
                                    // Neither: a row posted before both were
                                    // recorded. The id is not useful, but it is
                                    // honest, and it is what a repair reads.
                                    type: 'field',
                                    value: 'accountId',
                                    scale: 'title',
                                    condition: { all: [
                                        { field: 'accountNo', operator: 'empty' },
                                        { field: 'accountIdName', operator: 'empty' }
                                    ] }
                                },
                                {
                                    type: 'field',
                                    value: 'description',
                                    scale: 'normal'
                                },
                                /*
                                 * What kind of accounting event the line is, in
                                 * words. The code is what code reads; a journal is
                                 * read by people, so the four posting rulesets now
                                 * denormalize the name at posting time in the
                                 * company's own language — the same bargain
                                 * accountIdName and documentLabel already make.
                                 *
                                 * The raw code is the fallback, for a row posted
                                 * before they did. Showing 'PAYMENT' is poor; not
                                 * saying what the line is at all is worse.
                                 */
                                {
                                    type: 'field',
                                    value: 'typeName',
                                    scale: 'normal',
                                    prefix: 'journal.display.line.type',
                                    condition: { field: 'typeName', operator: 'notEmpty' }
                                },
                                {
                                    type: 'field',
                                    value: 'type',
                                    scale: 'normal',
                                    prefix: 'journal.display.line.type',
                                    condition: { all: [
                                        { field: 'typeName', operator: 'empty' },
                                        { field: 'type', operator: 'notEmpty' }
                                    ] }
                                },
                                {
                                    // Who the leg is against — the customer on a
                                    // receivable, the supplier on a payable. Every
                                    // ruleset put it on its ledger rows and then
                                    // dropped it reshaping them into lines[], so
                                    // the ledger knew and the journal did not.
                                    type: 'field',
                                    value: 'typeRefIdName',
                                    scale: 'normal',
                                    prefix: 'journal.display.line.counterparty',
                                    condition: { field: 'typeRefIdName', operator: 'notEmpty' }
                                },
                                {
                                    // The invoice or expense the leg belongs to or settles.
                                    type: 'field',
                                    value: 'documentNumber',
                                    scale: 'normal',
                                    prefix: 'journal.display.line.document',
                                    condition: { field: 'documentNumber', operator: 'notEmpty' }
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'debitAmount',
                                    scale: 'title',
                                    condition: { field: 'debitAmount', operator: 'gt', value: 0 },
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'amount',
                                    value: 'creditAmount',
                                    scale: 'title',
                                    condition: { field: 'creditAmount', operator: 'gt', value: 0 },
                                    variant: 'noMargin'
                                },
                                {
                                    // The tax treatment the leg was posted under,
                                    // which is what a VAT return is reconciled
                                    // against. The name when the line was built by
                                    // the manual-journal card's picker, the code
                                    // otherwise — postSale and postCreditNote
                                    // record `vatTaxId` alone.
                                    type: 'field',
                                    value: 'vatTaxIdName',
                                    scale: 'normal',
                                    prefix: 'journal.display.line.vat',
                                    condition: { field: 'vatTaxIdName', operator: 'notEmpty' }
                                },
                                {
                                    type: 'field',
                                    value: 'vatTaxId',
                                    scale: 'normal',
                                    prefix: 'journal.display.line.vat',
                                    condition: { all: [
                                        { field: 'vatTaxIdName', operator: 'empty' },
                                        { field: 'vatTaxId', operator: 'notEmpty' }
                                    ] }
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },
    portalInvoiceDisplayView: {
        entity: 'invoice',
        path: 'invoice',
        titleBar: { mergeParams: ['number'] },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    id: 'portalInvoiceDisplayView.download',
                    action: 'download',
                    label: 'all.form.button.download',
                    icon: 'send',
                    variant: 'primary',
                    confirm: false
                }
            ],
            actions: {
                archive: { message: 'invoice.action.archive.message' },
                unarchive: { message: 'invoice.action.unarchive.message' }
            }
        },
        width: '100%',
        notifications: [
            {
                type: 'error',
                message: 'invoice.display.message.unpaid',
                condition: { field: 'hasPayment', operator: 'equals', value: false }
            },
            {
                type: 'success',
                message: 'invoice.display.message.paid',
                condition: { field: 'paid', operator: 'equals', value: true }
            },
            {
                type: 'warning',
                message: 'invoice.display.message.partially.paid',
                condition: { all: [{ field: 'paid', operator: 'equals', value: false }, { field: 'hasPayment', operator: 'equals', value: true }] }
            }
        ],
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'actionButton',
                    title: 'all.form.button.preview',
                    entity: 'invoice',
                    modalFormRef: 'documentPreview'
                },
                {
                    type: 'optionPanel',
                    id: 'optionPanel',
                    items: [
                        {
                            type: 'modal',
                            title: 'invoice.form.mobile.panel.design',
                            action: 'showModal',
                            icon: 'design',
                            modalFormRef: 'invoiceDesign'
                        }
                    ]
                }
            ]
        },

        sections: [
            {
                id: 'invoiceHeader',
                meta: {
                    type: 'regular',
                    width: '900px'
                },
                displaySection: {
                    type: 'regular',
                    emptyField: 'number',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 4,
                            basis: '40%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title',
                                    prefix: 'invoice.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 6,
                            basis: '60%',
                            align: 'right',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'customerName',
                                    scale: 'title',
                                    icon: 'people',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'customerEmail',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['customerAddress_street', 'customerAddress_postCode', 'customerAddress_city', 'customerCountryName'],
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'invoiceLines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    width: '900px',
                },
                displaySection: {
                    type: 'lines',
                    emptyField: 'itemName',
                    emptyMessage: 'invoice.form.product.missing.message',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    linesArray: 'lines',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'netSalesAmount',
                                    scale: 'title',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'currency',
                                    value: 'currency',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ],
                        }
                    ]
                }
            },
            {
                id: 'invoiceSummary',
                meta: {
                    type: 'totals',
                    width: '900px',
                    align: 'end',
                    variant: 'transparent'
                },
                displaySection: {
                    type: 'totals',
                    elements: [
                        {
                            type: 'line',
                            value: 'totalNetSalesAmountBeforeDiscount',
                            scale: 'normal',
                            label: 'invoice.form.subtotal',
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount.percentage',
                            // The multiplier form is what keeps this a bare 10
                            // rather than a formatted 10.00 -- the same idiom the
                            // VAT row uses to turn a rate into a percentage.
                            labelParams: [['documentDiscountValue', 1]],
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'percentage' }
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'amount' }
                        },
                        {
                            type: 'line',
                            value: 'totalNetSalesAmount',
                            scale: 'normal',
                            label: 'all.form.total.taxable',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        },
                        {
                            type: 'array',
                            value: 'vatTaxAmount',
                            subEntity: 'vatTaxes',
                            scale: 'normal',
                            label: 'invoice.form.vatLine',
                            labelParams: [['vatTaxRate', 100], 'vatTaxAmount'],
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'totalGrossSalesAmount',
                            scale: 'large',
                            label: 'invoice.form.total',
                            decorator: 'currency'
                        }
                    ]
                }
            },
            {
                id: 'invoiceTerms',
                meta: {
                    type: 'regular',
                    width: '900px',
                },
                displaySection: {
                    emptyField: 'terms',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'all.display.terms',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'terms',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
        ]
    },
    purchaseOrderDisplayView: {
        entity: 'purchaseOrder',
        path: 'purchaseOrder',
        titleBar: { mergeParams: ['number'] },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [],
            menuItems: [
                {
                    action: 'archive',
                    label: 'all.menu.item.archive',
                    confirm: false,
                    dependency: { id: 'archived', value: false }
                },
                {
                    action: 'unarchive',
                    label: 'all.menu.item.unarchive',
                    confirm: false,
                    dependency: { id: 'archived', value: true }
                },
                {
                    action: 'createReceipt',
                    label: 'purchases.purchaseOrder.menu.createReceipt',
                    confirm: false,
                    target: '/inventory/receipt/newFromPO/:id'
                },
                {
                    action: 'createExpense',
                    label: 'purchases.purchaseOrder.menu.createExpense',
                    confirm: false,
                    target: '/purchases/expense/newFromPO/:id'
                }
            ],
            actions: {
                archive: { message: 'purchases.purchaseOrder.action.archive.message' },
                unarchive: { message: 'purchases.purchaseOrder.action.unarchive.message' }
            }
        },
        width: '100%',
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'actionButton',
                    title: 'all.form.button.preview',
                    entity: 'purchaseOrder',
                    modalFormRef: 'documentPreview'
                },
                {
                    type: 'optionPanel',
                    id: 'optionPanel',
                    items: [
                        {
                            type: 'modal',
                            title: 'purchases.purchaseOrder.form.mobile.panel.design',
                            action: 'showModal',
                            icon: 'design',
                            modalFormRef: 'invoiceDesign'
                        }
                    ]
                }
            ]
        },
        sections: [
            {
                id: 'purchaseOrderDisplayHeader',
                meta: {
                    type: 'regular',
                    width: '900px'
                },
                displaySection: {
                    type: 'regular',
                    emptyField: 'number',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 4,
                            basis: '40%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'bookedNumber',
                                    scale: 'title',
                                    prefix: 'purchases.purchaseOrder.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 6,
                            basis: '60%',
                            align: 'right',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'supplierName',
                                    scale: 'title',
                                    icon: 'people',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['supplierAddress_street', 'supplierAddress_postCode', 'supplierAddress_city', 'supplierCountryName'],
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'purchaseOrderDisplayLines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    width: '900px',
                },
                displaySection: {
                    type: 'lines',
                    emptyField: 'itemName',
                    emptyMessage: 'purchases.purchaseOrder.form.line.add',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    linesArray: 'lines',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'itemQuantity',
                                    scale: 'title',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'unitName',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },
    quoteDisplayView: {
        entity: 'quote',
        path: 'quote',
        titleBar: { mergeParams: ['number'] },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    id: 'quoteDisplayView.send',
                    action: 'send',
                    label: 'all.form.button.send',
                    icon: 'send',
                    variant: 'primary',
                    confirm: true,
                    modalConfig: 'quoteSendDialog'
                }
            ],
            menuItems: [
                {
                    action: 'save',
                    label: 'all.menu.item.save',
                    confirm: false
                },
                {
                    action: 'archive',
                    label: 'all.menu.item.archive',
                    confirm: false,
                    dependency: { id: 'archived', value: false }
                },
                {
                    action: 'unarchive',
                    label: 'all.menu.item.unarchive',
                    confirm: false,
                    dependency: { id: 'archived', value: true }
                },
                {
                    action: 'invoice',
                    label: 'all.menu.item.invoice',
                    confirm: true,
                    modalConfig: 'quoteConfirmInvoice',
                    target: '/sales/invoice/newFromQuote/:id'
                },
                {
                    action: 'createShipment',
                    label: 'quote.menu.createShipment',
                    confirm: true,
                    modalConfig: 'quoteConfirmCreateShipment'
                }
            ],
            actions: {
                archive: { message: 'quote.action.archive.message' },
                unarchive: { message: 'quote.action.unarchive.message' }
            }
        },
        width: '100%',
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'actionButton',
                    title: 'all.form.button.preview',
                    entity: 'quote',
                    modalFormRef: 'documentPreview'
                },
                {
                    type: 'optionPanel',
                    id: 'optionPanel',
                    items: [
                        {
                            type: 'modal',
                            title: 'quote.form.mobile.panel.design',
                            action: 'showModal',
                            icon: 'design',
                            modalFormRef: 'invoiceDesign'
                        }
                    ]
                }
            ]
        },
        sections: [
            {
                id: 'quoteHeader',
                meta: {
                    type: 'regular',
                    width: '100%'
                },
                displaySection: {
                    type: 'regular',
                    emptyField: 'number',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 4,
                            basis: '40%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title',
                                    prefix: 'quote.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 6,
                            basis: '60%',
                            align: 'right',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'customerName',
                                    scale: 'title',
                                    icon: 'people',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'customerEmail',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['customerAddress_street', 'customerAddress_postCode', 'customerAddress_city', 'customerCountryName'],
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'quoteLines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    width: '900px',
                },
                displaySection: {
                    type: 'lines',
                    emptyField: 'itemName',
                    emptyMessage: 'quote.form.product.missing.message',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    linesArray: 'lines',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'netSalesAmount',
                                    scale: 'title',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'currency',
                                    value: 'currency',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ],
                        }
                    ]
                }
            },
            {
                id: 'quoteSummary',
                meta: {
                    type: 'totals',
                    width: '900px',
                    align: 'end',
                    variant: 'transparent'
                },
                displaySection: {
                    type: 'totals',
                    elements: [
                        {
                            type: 'line',
                            value: 'totalNetSalesAmountBeforeDiscount',
                            scale: 'normal',
                            label: 'invoice.form.subtotal',
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount.percentage',
                            // The multiplier form is what keeps this a bare 10
                            // rather than a formatted 10.00 -- the same idiom the
                            // VAT row uses to turn a rate into a percentage.
                            labelParams: [['documentDiscountValue', 1]],
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'percentage' }
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'amount' }
                        },
                        {
                            type: 'line',
                            value: 'totalNetSalesAmount',
                            scale: 'normal',
                            label: 'all.form.total.taxable',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        },
                        {
                            type: 'array',
                            value: 'vatTaxAmount',
                            subEntity: 'vatTaxes',
                            scale: 'normal',
                            label: 'invoice.form.vatLine',
                            labelParams: [['vatTaxRate', 100], 'vatTaxAmount'],
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'totalGrossSalesAmount',
                            scale: 'large',
                            label: 'invoice.form.total',
                            decorator: 'currency'
                        }
                    ]
                }
            },
            {
                id: 'quoteTerms',
                meta: {
                    type: 'regular',
                    width: '900px',
                },
                displaySection: {
                    emptyField: 'terms',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'all.display.terms',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'terms',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
        ]
    },
    stockAdjustmentDisplayView: {
        entity: 'stockAdjustment',
        path: 'stockAdjustment',
        titleBar: { mergeParams: ['number'] },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    id: 'stockAdjustmentDisplayView.close',
                    action: 'close',
                    label: 'all.form.button.close',
                    icon: 'close',
                    variant: 'primary',
                    confirm: false,
                    modalConfig: 'confirmClose'
                }
            ]
        },
        width: '100%',
        sections: [
            {
                id: 'stockAdjustmentDiplayHeader',
                meta: {
                    type: 'regular',
                    width: '756px'
                },
                displaySection: {
                    type: 'regular',
                    emptyField: 'number',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 5,
                            basis: '50%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 5,
                            basis: '50%',
                            align: 'right',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'note',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'invoiceLines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    width: '756px',
                },
                displaySection: {
                    type: 'lines',
                    emptyField: 'itemName',
                    emptyMessage: 'invoice.form.product.missing.message',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    linesArray: 'lines',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'quantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'quantity',
                                    scale: 'title',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'unitName',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ],
                        }
                    ]
                }
            },
        ]
    },
    stockMovementDisplayView: {
        entity: 'stockAdjustment',
        path: 'stockAdjustment',
        titleBar: { mergeParams: ['number'] },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    id: 'stockMovementDisplayView.close',
                    action: 'close',
                    label: 'all.form.button.close',
                    icon: 'close',
                    variant: 'primary',
                    confirm: false,
                    modalConfig: 'confirmClose'
                }
            ]
        },
        width: '100%',
        sections: [
            {
                id: 'stockAdjustmentDiplayHeader',
                meta: {
                    type: 'regular',
                    width: '756px'
                },
                displaySection: {
                    type: 'regular',
                    emptyField: 'number',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 5,
                            basis: '50%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 5,
                            basis: '50%',
                            align: 'right',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'note',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'movementItemLines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    width: '756px',
                },
                displaySection: {
                    type: 'lines',
                    emptyField: 'itemName',
                    emptyMessage: 'invoice.form.product.missing.message',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    linesArray: 'lines',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'quantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'quantity',
                                    scale: 'title',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'unitName',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ],
                        }
                    ]
                }
            },
            {
                id: 'movementLocationLines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    width: '756px',
                },
                displaySection: {
                    type: 'lines',
                    emptyField: 'itemName',
                    emptyMessage: 'invoice.form.product.missing.message',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    linesArray: 'lines',
                    columns: [
                        {
                            weight: 5,
                            basis: '50%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'all.from',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'origin.locationId',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 5,
                            basis: '50%',
                            align: 'start',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'all.to',
                                    scale: 'title',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'destination.locationId',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ],
                        }
                    ]
                }
            },
        ]
    },
    stockReceiptDisplayView: {
        entity: 'stockReceipt',
        path: 'stockReceipt',
        titleBar: { mergeParams: ['number'] },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    id: 'stockReceiptDisplayView.close',
                    action: 'close',
                    label: 'all.form.button.close',
                    icon: 'close',
                    variant: 'primary',
                    confirm: false
                }
            ]
        },
        width: '100%',
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'actionButton',
                    title: 'all.form.button.preview',
                    entity: 'stockReceipt',
                    modalFormRef: 'documentPreview'
                },
                {
                    type: 'optionPanel',
                    id: 'optionPanel',
                    items: [
                        {
                            type: 'modal',
                            title: 'inventory.receipt.form.mobile.panel.design',
                            action: 'showModal',
                            icon: 'design',
                            modalFormRef: 'inventoryShipmentDesign'
                        }
                    ]
                }
            ]
        },
        sections: [
            {
                id: 'stockReceiptDisplayHeader',
                meta: {
                    type: 'regular',
                    width: '900px'
                },
                displaySection: {
                    type: 'regular',
                    emptyField: 'number',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 4,
                            basis: '40%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title',
                                    prefix: 'inventory.receipt.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 6,
                            basis: '60%',
                            align: 'right',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'supplierName',
                                    scale: 'title',
                                    icon: 'receipt',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'linkedDocumentNumber',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'stockReceiptLines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    width: '900px',
                },
                displaySection: {
                    type: 'lines',
                    emptyField: 'itemName',
                    emptyMessage: 'inventory.receipt.form.line.missing.message',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    linesArray: 'lines',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'itemQuantity',
                                    scale: 'title',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'unitName',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ]
                        }
                    ]
                }
            },
        ]
    },
    stockShipmentDisplayView: {
        entity: 'stockShipment',
        path: 'stockShipment',
        titleBar: { mergeParams: ['number'] },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    id: 'stockShipmentDisplayView.close',
                    action: 'close',
                    label: 'all.form.button.close',
                    icon: 'close',
                    variant: 'primary',
                    confirm: false,
                    modalConfig: 'confirmClose'
                }
            ]
        },
        width: '100%',
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'actionButton',
                    title: 'all.form.button.preview',
                    entity: 'stockShipment',
                    modalFormRef: 'documentPreview'
                },
                {
                    type: 'optionPanel',
                    id: 'optionPanel',
                    items: [
                        {
                            type: 'modal',
                            title: 'inventory.shipment.form.mobile.panel.design',
                            action: 'showModal',
                            icon: 'design',
                            modalFormRef: 'inventoryShipmentDesign'
                        }
                    ]
                }
            ]
        },
        sections: [
            {
                id: 'stockShipmentDiplayHeader',
                meta: {
                    type: 'regular',
                    width: '900px'
                },
                displaySection: {
                    type: 'regular',
                    emptyField: 'number',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 4,
                            basis: '40%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title',
                                    prefix: 'inventory.shipment.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 6,
                            basis: '60%',
                            align: 'right',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'customerName',
                                    scale: 'title',
                                    icon: 'people',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'customerEmail',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['customerAddress_street', 'customerAddress_postCode', 'customerAddress_city', 'customerCountryName'],
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'stockShipmentLines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    width: '900px',
                },
                displaySection: {
                    type: 'lines',
                    emptyField: 'itemName',
                    emptyMessage: 'invoice.form.product.missing.message',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    linesArray: 'lines',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'itemQuantity',
                                    scale: 'title',
                                    variant: 'noMargin'
                                },
                                {
                                    type: 'field',
                                    value: 'unitName',
                                    scale: 'normal',
                                    variant: 'noMargin'
                                }
                            ],
                        }
                    ]
                }
            },
        ]
    },
    warehouseOrderDisplayView: {
        entity: 'warehouseOrder',
        path: 'warehouseOrder',
        titleBar: { mergeParams: ['number'] },
        cardTitle: {
            title: 'all.form.button.more',
            menuItems: [
                {
                    action: 'sequence',
                    label: 'warehouseOrder.form.menu.sequence',
                    confirm: false,
                    dependency: { id: 'completed', value: false }
                },
                {
                    action: 'complete',
                    label: 'warehouseOrder.form.menu.complete',
                    confirm: true,
                    modalConfig: 'warehouseOrderConfirmComplete',
                    dependency: { id: 'completed', value: false }
                },
                {
                    action: 'uncomplete',
                    label: 'warehouseOrder.form.menu.uncomplete',
                    confirm: false,
                    dependency: { id: 'completed', value: true }
                }
            ],
            actions: {
                sequence: { message: 'warehouseOrder.sequenceComplete', reload: true }
            }
        },
        width: '100%',
        tabs: [
            { key: 'lines', label: 'warehouseOrder.tab.lines' },
            { key: 'route', label: 'warehouseOrder.route.title' }
        ],
        sections: [
            {
                id: 'warehouseOrderDisplayHeader',
                meta: { type: 'regular', width: '756px' },
                displaySection: {
                    type: 'regular',
                    emptyField: 'number',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    columns: [
                        {
                            weight: 4, basis: '40%',
                            elements: [
                                { type: 'field', value: 'number', scale: 'title' },
                                { type: 'field', value: 'typeName', scale: 'normal' },
                                { type: 'date', value: 'date', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 6, basis: '60%', align: 'right',
                            elements: [
                                { type: 'field', value: 'warehouseName', scale: 'title', variant: 'noMargin' },
                                { type: 'field', value: 'assignedToName', scale: 'normal', variant: 'noMargin' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'warehouseOrderDisplayLines',
                meta: {
                    type: 'lines',
                    tab: 'lines',
                    linesArray: 'lines',
                    width: '756px',
                },
                displaySection: {
                    type: 'lines',
                    emptyField: 'itemName',
                    emptyMessage: 'warehouseOrder.form.line.missing',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    linesArray: 'lines',
                    orderBy: 'sortOrder',
                    columns: [
                        {
                            weight: 7, basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'quantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} → ${2}',
                                    mergeParams: ['fromLocationId', 'toLocationId'],
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3, basis: '30%', align: 'end',
                            elements: [
                                { type: 'amount', value: 'quantity', scale: 'title', variant: 'noMargin' },
                                { type: 'field', value: 'unitName', scale: 'normal', variant: 'noMargin' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'warehouseOrderRouteStops',
                meta: {
                    type: 'lines',
                    tab: 'route',
                    linesArray: 'routeStops',
                    width: '756px'
                },
                displaySection: {
                    type: 'lines',
                    emptyField: 'locationId',
                    emptyMessage: 'warehouseOrder.route.empty',
                    showEditOnHover: false,
                    showEmptyPrompt: false,
                    linesArray: 'routeStops',
                    columns: [
                        {
                            weight: 7, basis: '70%',
                            elements: [
                                { type: 'merge', value: '${1}. ${2}', mergeParams: ['seq', 'locationId'], scale: 'title' },
                                { type: 'field', value: 'summary', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 3, basis: '30%', align: 'end',
                            elements: [
                                { type: 'field', value: 'actionLabel', scale: 'title', variant: 'noMargin' },
                                { type: 'field', value: 'position', scale: 'normal', variant: 'noMargin' }
                            ]
                        }
                    ]
                }
            }
        ]
    }
}